<div class="modal-header">
    <h5 class="modal-title page-titles-font">{{ title }}</h5>
</div>
<div class="modal-body font-sm"> {{ message }} </div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="decline()">{{ btnCancelText }}</button>
    <button type="button" class="btn btn-primary btn-sm" (click)="accept()">{{ btnOkText }}</button>
</div>